// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SaasIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 34 28">
    <path
      fill="url(#saas_svga)"
      d="m29.83 18.97-.08.01a5.82 5.82 0 0 0-11.02-1.61 4.98 4.98 0 0 0 .27 9.96l10.83-.03a4.17 4.17 0 0 0 0-8.33M10.67 1.1v3.48A9.93 9.93 0 0 0 7.34 21.4v-4.07h3.33v10h-10V24h4.55a13.32 13.32 0 0 1 5.45-22.9M27.33 4h-4.55a13.3 13.3 0 0 1 4.44 8.33h-3.37a10 10 0 0 0-3.18-5.73v4.07h-3.34v-10h10z"
    />
    <defs>
      <linearGradient
        id="saas_svga"
        x1={0.67}
        x2={27.63}
        y1={0.67}
        y2={32.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "Saas",
);
export default SaasIcon;
